import { createFileRoute } from "@tanstack/react-router";
import AgendaConsultoria from "@/pages/AgendaConsultoria";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const canonicalUrl = "https://agenciaseoevolution.com/agenda-consultoria";

const breadcrumbSchema = buildBreadcrumb([{ name: "Agenda tu diagnóstico", path: "/agenda-consultoria" }]);

export const Route = createFileRoute("/agenda-consultoria")({
  head: () => ({
    meta: [
      { title: "Solicita un diagnóstico de tu empresa | SEOEVOLUTION" },
      {
        name: "description",
        content:
          "Solicita un diagnóstico de tu empresa. Analizamos tu mercado, competencia y objetivos y te proponemos alcance e inversión a medida en SEO, Google Maps e IA.",
      },
      {
        name: "keywords",
        content: "consultoría SEO, análisis web, auditoría SEO, estrategia digital, posicionamiento web",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonicalUrl },
      { property: "og:title", content: "Solicita un diagnóstico de tu empresa | SEOEVOLUTION" },
      {
        property: "og:description",
        content:
          "Solicita un diagnóstico de tu empresa. Analizamos tu mercado, competencia y objetivos y te proponemos alcance e inversión a medida en SEO, Google Maps e IA.",
      },
      { name: "twitter:title", content: "Solicita un diagnóstico de tu empresa | SEOEVOLUTION" },
      {
        name: "twitter:description",
        content:
          "Solicita un diagnóstico de tu empresa. Analizamos tu mercado, competencia y objetivos y te proponemos alcance e inversión a medida en SEO, Google Maps e IA.",
      },
    ],
    links: [{ rel: "canonical", href: canonicalUrl }],
    scripts: [ldJson(breadcrumbSchema)],
  }),
  component: AgendaConsultoria,
});
